module.exports = __webpack_public_path__ + "img/国企单位.2f58bd49.png";